import React from 'react';
import { Content, Dates, Days, LeftSection, TodayText } from './styles';
import dayjs from 'dayjs';

interface Props {
  dayName: string;
  date: number;
}

export default function CardHeader(Props: Props) {
  const { dayName, date } = Props;
  const today = dayjs();
  const isToday = date === today.date() && dayName === today.format('dddd');
  return (
    <div>
      {/* <Box> */}
      <Content>
        <LeftSection>
          <Days>{dayName}</Days>
          {isToday && (
            <TodayText>
              <p>Today</p>
            </TodayText>
          )}
        </LeftSection>
        <Dates className='date-text'>{date}</Dates>
      </Content>
      {/* </Box> */}
    </div>
  );
}
